import React, { forwardRef } from 'react';
import DatePicker from 'react-multi-date-picker';
import { Controller } from 'react-hook-form';
import { FormHelperText } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { StyledUiDatePicker } from './UiDatePicker.styles';

const UiDatePicker = forwardRef(({ name, control, ...otherProps }, ref) => {
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <StyledUiDatePicker
              className={classNames('ui-date-picker', error && 'error')}
            >
              <DatePicker
                {...otherProps}
                {...field}
                ref={ref}
                value={field?.value || ''}
                onChange={(date) => {
                  field?.onChange(date?.isValid ? date : '');
                }}
              />
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </StyledUiDatePicker>
          );
        }}
      />
    );
  }

  return (
    <StyledUiDatePicker className='ui-date-picker'>
      <DatePicker name={name} {...otherProps} />
    </StyledUiDatePicker>
  );
});

UiDatePicker.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  children: PropTypes.node,
};

export default UiDatePicker;
